module.exports = __webpack_public_path__ + "img/logo.abb5115f.png";